import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import styles from './Header/Header.module.scss';

const HeaderItems = ({ children = null }) => {
  const isHeaderRedesignVariant =
    useSoyuzExperiment('HeaderRedesign').get('behaviour') === 'variant';

  const classes = classNames(styles.nav, {
    [styles['nav--redesign']]: isHeaderRedesignVariant
  });

  return <ul className={classes}>{children}</ul>;
};

export default HeaderItems;

HeaderItems.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.array
  ])
};
